<template>
	<footer class="main">
		&copy; 2025 <strong>CORAA</strong>
		<loader style="position: fixed;z-index: 10000;"  v-if="$root.isLoading == true" object="#41409e" color1="#ffffff" color2="#3a67ac" size="5" speed="2" bg="#343a40" objectbg="#999793" opacity="80" disableScrolling="false" name="circular"></loader>
	
	</footer>
</template>

<script type="text/javascript">
	export default {
        mounted() {
					
        }
    }
</script>
